// @ts-check
require('es6-promise/auto');
require('reflect-metadata');
require('setimmediate');
const { Container } = require('inversify');

const runtimeConfig = {
    basePath: process.env.REACT_APP_BASE_PATH ?? '/',
    backendBasePath: process.env.REACT_APP_BACKEND_BASE_PATH ?? '/authlance/loop',
    googleAnalyticsMeasurementId: process.env.REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID ?? 'G-QFFCVDS186',
    homeUrl: process.env.REACT_APP_HOME_URL ?? '',
    showProfileGender: true,
    showProfileBirthdate: true,
    showChangePassword: true,
};

const resolvedBasePath = runtimeConfig.basePath;
const resolvedBackendBasePath = runtimeConfig.backendBasePath;

const { setRuntimeConfig } = require('@authlance/core/lib/browser/runtime-config');
setRuntimeConfig(runtimeConfig);

function createFrontendContainer() {
    const container = new Container();
    const _ = require('../../lib/browser');
    const brandicon = require('../../src/assets/brandicon.svg');
    const brandLogo = require('../../src/assets/brandlogo.svg');
    const { BRAND_ICON, BRAND_LOGO, BASE_DASHBOARD_PATH } = require('@authlance/core/lib/browser');
    const { FrontendApplication } = require('@authlance/core/lib/browser/frontend-application');
    const { frontendApplicationModule } = require('@authlance/core/lib/browser/frontend-application-module');
    const { messagingFrontendModule } = require('@authlance/core/lib/browser/messaging/messaging-frontend-module');
    const { LoopContainer } = require('@authlance/core/lib/common/common');

    container.bind(BRAND_ICON).toConstantValue(brandicon);
    container.bind(BRAND_LOGO).toConstantValue(brandLogo);
    container.bind(BASE_DASHBOARD_PATH).toConstantValue(resolvedBasePath);
    container.load(frontendApplicationModule);
    container.load(messagingFrontendModule);
    container.bind(LoopContainer).toConstantValue(container);
    return { container, FrontendApplication };
}

const { container, FrontendApplication } = createFrontendContainer();

const { bindContainerToStore } = require('@authlance/core/lib/browser/frontend-application');
bindContainerToStore(container);

function load(raw) {
    return Promise.resolve(raw.default).then(
        module => container.load(module)
    );
}

function start() {
    const application = container.get(FrontendApplication);
    application.container = container;
    application.start();
}

const bootstrap = Promise.resolve()
    .then(function () { return Promise.resolve(require('@authlance/common/lib/browser/front-end-common-module')).then(load) })
    .then(function () { return Promise.resolve(require('@authlance/identity/lib/browser/front-end-identity-module')).then(load) })
    .then(function () { return Promise.resolve(require('@authlance/license-core/lib/browser/front-end-core-module')).then(load) })
    .then(function () { return Promise.resolve(require('@authlance/license-layout/lib/browser/front-end-license-layout-module')).then(load) })
    .then(function () { return Promise.resolve(require('@authlance/saas/lib/browser/front-end-saas-module')).then(load) })
    .then(start).catch(reason => {
        console.error('Failed to start the frontend application.');
        if (reason) {
            console.error(reason);
        }
    });

module.exports = bootstrap;
module.exports.runtimeConfig = runtimeConfig;
module.exports.createFrontendContainer = createFrontendContainer;
module.exports.container = container;
module.exports.FrontendApplication = FrontendApplication;
module.exports.start = start;
module.exports.resolvedBasePath = resolvedBasePath;
module.exports.resolvedBackendBasePath = resolvedBackendBasePath;
